import React from 'react';
import type { TransformedReport } from '../types';
import AvatarSvg, { SEGMENT_COLORS } from './AvatarSvg';

interface SegmentsSlideProps {
  data: TransformedReport;
}

/**
 * SegmentsSlide - Slide 7: Three segment cards with funnel badges.
 * Layout follows v0 report-sample.html sn6 structure.
 */
const SegmentsSlide: React.FC<SegmentsSlideProps> = ({ data }) => {
  const segments = data.segments ?? [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="slide-hdr">
        <p className="sl">WHO — Segments</p>
        <h2>届ける3つの相手</h2>
        <p className="bt">ファネル別に、最も効果が見込める3つのセグメントを設定しました</p>
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <div className="segments-grid">
          {segments.slice(0, 3).map((seg, i) => (
            <div
              key={i}
              className="card"
              style={{
                borderTop: '4px solid #1D1926',
                borderRadius: 8,
                padding: 'clamp(12px, 2vmin, 24px)',
              }}
            >
              {/* Funnel badge */}
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'clamp(6px, 1vmin, 12px)' }}>
                <span className="pill">{seg.funnel_stage || `Segment ${i + 1}`}</span>
              </div>

              {/* Avatar */}
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'clamp(8px, 1.2vmin, 16px)' }}>
                <div style={{ width: 'clamp(48px, 7vmin, 80px)', height: 'clamp(48px, 7vmin, 80px)', borderRadius: '50%', background: '#E4E0ED', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <AvatarSvg variant={i} color={SEGMENT_COLORS[i]} className="w-10 h-10" />
                </div>
              </div>

              {/* Name */}
              <p style={{ fontSize: 'clamp(14px, 2.2vmin, 18px)', fontWeight: 700, textAlign: 'center', lineHeight: 1.4, marginBottom: 'clamp(8px, 1.2vmin, 16px)' }}>
                {seg.name || ''}
              </p>

              {/* Divider */}
              <div style={{ width: 32, height: 2, background: '#E4E0ED', margin: '0 auto clamp(8px, 1.2vmin, 16px)' }} />

              {/* Demographics */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(4px, 0.6vmin, 8px)', fontSize: 'clamp(11px, 1.5vmin, 13px)' }}>
                {seg.demographics?.age_range && (
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                    <span className="seg-label" style={{ fontSize: 11, color: 'rgba(29,25,38,0.4)', fontFamily: 'Inter, sans-serif', fontWeight: 600, width: 16 }}>Age</span>
                    <span>{seg.demographics.age_range}</span>
                  </div>
                )}
                {seg.demographics?.occupation && (
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                    <span className="seg-label" style={{ fontSize: 11, color: 'rgba(29,25,38,0.4)', fontFamily: 'Inter, sans-serif', fontWeight: 600, width: 16 }}>Job</span>
                    <span>{seg.demographics.occupation}</span>
                  </div>
                )}
                {seg.emotion_map?.pain && (
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                    <span className="seg-label" style={{ fontSize: 11, color: 'rgba(29,25,38,0.4)', fontFamily: 'Inter, sans-serif', fontWeight: 600, width: 16 }}>Why</span>
                    <span>{seg.emotion_map.pain}</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SegmentsSlide;
